import { Fade, styled } from '@mui/material'
import {
  ResolutionValueType,
  SELECT_INTERVAL_MENU,
  RESOLUTION_OPTIONS,
} from 'constants/chart'
import useWindow from 'hooks/useWindow'
import { FC, memo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateFavoriteResloution } from 'store/orderbook/actions'
import { useResolution, useFavoriteResolution } from 'store/orderbook/hooks'
import { Flex, FlexCenter } from 'styles'
import { useOnClickOutside } from 'usehooks-ts'
import { ReactComponent as ArrrowSvg } from './assets/arrow.svg'
import { ReactComponent as PinSvg } from './assets/pin.svg'
import { ReactComponent as UnPinSvg } from './assets/unpin.svg'
import { updateResolution } from 'store/orderbook/actions'

const IntervalSelectWrap = styled('div')`
  display: flex;
  align-items: center;
  position: relative;
`
export const IntervalSelectBtn = styled(Flex)<{ isIn?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  width: 22px;
  height: 22px;
  font-weight: 600;
  font-size: 12px;
  position: relative;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: rgba(55, 60, 69, 1);
    svg {
      color: rgba(160, 238, 9, 1);
    }
  }

  svg {
    height: 7px;
    width: 7px;
    transform: rotate(180deg);
    color: rgba(149, 164, 173, 1);
  }
`

const Popup = styled(Flex)`
  margin-top: 3px;
  width: 130px;
  z-index: 10;
  position: absolute;
  top: 30px;
  flex-direction: column;
  left: 0;
  /* background-color: ${(props) => props.theme.color.bgLightGray}; */
  border-radius: 6px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: rgba(30, 35, 41, 1);
  /* background-color: ${(props) => props.theme.color.bgLightGray}; */
  /* ${(props) => props.theme.breakpoints.down('md')} {
    margin-left: calc(-100vw + 74px);
    border-radius: 0;
    width: 100vw;
  } */
`

const Menu = styled('div')`
  border-bottom: 1px solid rgba(43, 49, 58, 1);
  &:last-child {
    border-bottom: unset;
  }
  font-size: 12px;
  /* padding-inline: 12px; */
  color: rgba(149, 164, 173, 1);
`

const MenuTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 10px;
  align-items: center;
  padding-bottom: 10px;
  padding-left: 12px;
  padding-right: 12px;
  svg {
    cursor: pointer;
    transition: all ease 0.2s;
    color: rgba(160, 238, 9, 1);

    &:hover {
    }
  }

  svg.down {
    transform: rotate(180deg);
    color: unset;
  }
`

const MenuItem = styled('div')`
  height: 32px;
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  gap: 4;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  &:hover {
    background-color: rgba(42, 49, 57, 1);
    border-radius: 4px;
  }
  transition: all ease-in 0.2s;

  svg {
    transform: scale(0.8);
  }
`

export const IntervalSelector: FC = memo(() => {
  const dispatch = useDispatch()
  const [isIn, setIsIn] = useState(false)
  const wrap = useRef<any>()
  const resolution = useResolution()
  const { isMobile } = useWindow()
  const _favorite = useFavoriteResolution()
  const [showMenuItemIndex, setShowMenuItemIndex] = useState([0, 1, 2, 3, 4])

  const MENU_KEYS = Object.keys(SELECT_INTERVAL_MENU)

  useOnClickOutside(wrap, () => setIsIn(false))

  return (
    <IntervalSelectWrap ref={wrap}>
      <IntervalSelectBtn
        onClick={() => setIsIn(true)}
        // className={IntervalSelectBtnClassName}
        isIn={isIn ? 1 : 2}
      >
        <ArrrowSvg className="arrow-down" />
      </IntervalSelectBtn>
      <Fade in={isIn} timeout={200}>
        <Popup>
          {MENU_KEYS.map((d, i) => {
            return (
              <Menu>
                <MenuTitle>
                  {d}
                  <ArrrowSvg
                    className={showMenuItemIndex.indexOf(i) < 0 ? 'down' : ''}
                    onClick={() => {
                      const index = showMenuItemIndex.indexOf(i)
                      if (showMenuItemIndex.indexOf(i) > -1) {
                        setShowMenuItemIndex((prev) => {
                          const arr = [...prev]
                          arr.splice(index, 1)
                          return arr
                        })
                      } else {
                        setShowMenuItemIndex((prev) => {
                          return [...prev, i]
                        })
                      }
                    }}
                  />
                </MenuTitle>
                {showMenuItemIndex.indexOf(i) > -1 &&
                  SELECT_INTERVAL_MENU[d].map((dd, ii) => {
                    return (
                      <MenuItem
                        key={ii}
                        onClick={() => {
                          dispatch(
                            updateResolution(
                              RESOLUTION_OPTIONS[
                                dd.value as ResolutionValueType
                              ],
                            ),
                          )
                          try {
                            window.tvWidget
                              .activeChart()
                              .setResolution(
                                RESOLUTION_OPTIONS[
                                  dd.value as ResolutionValueType
                                ],
                              )
                            setIsIn(false)
                          } catch (error) {}
                        }}
                      >
                        {dd.label}

                        {_favorite.indexOf(dd.value) > -1 && (
                          <PinSvg
                            onClick={() => {
                              console.log(
                                '[[resolution]]',
                                resolution,
                                dd.value,
                              )
                              if (
                                resolution ===
                                RESOLUTION_OPTIONS[
                                  dd.value as ResolutionValueType
                                ]
                              )
                                return
                              dispatch(
                                updateFavoriteResloution({
                                  type: 'del',
                                  value: dd.value,
                                }),
                              )
                            }}
                          />
                        )}

                        {_favorite.indexOf(dd.value) < 0 && (
                          <UnPinSvg
                            onClick={() => {
                              dispatch(
                                updateFavoriteResloution({
                                  type: 'add',
                                  value: dd.value,
                                }),
                              )
                            }}
                          />
                        )}
                      </MenuItem>
                    )
                  })}
              </Menu>
            )
          })}
        </Popup>
      </Fade>
    </IntervalSelectWrap>
  )
})
